module.exports = __webpack_public_path__ + "img/generated-1772425767922.d50c4e3c.png";